import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../api/client';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]     = useState(null);
  const [loading, setLoading] = useState(true);
  const [textSize, setTextSizeState] = useState(
    () => localStorage.getItem('gc_admin_text_size') || 'normal'
  );

  // Aplicar tamaño en <html>
  useEffect(() => {
    document.documentElement.setAttribute('data-text-size', textSize);
  }, [textSize]);

  function setTextSize(size) {
    if (!['normal', 'large'].includes(size)) return;
    localStorage.setItem('gc_admin_text_size', size);
    setTextSizeState(size);
  }

  function toggleTextSize() {
    setTextSize(textSize === 'normal' ? 'large' : 'normal');
  }

  useEffect(() => {
    const t = localStorage.getItem('gc_admin_token');
    if (!t) { setLoading(false); return; }
    api.me()
      .then(u => { if (u.isAdmin) setUser(u); else localStorage.removeItem('gc_admin_token'); })
      .catch(() => localStorage.removeItem('gc_admin_token'))
      .finally(() => setLoading(false));
  }, []);

  async function login(email, password) {
    const data = await api.login(email, password);
    localStorage.setItem('gc_admin_token', data.token);
    setUser(data.user);
  }

  function logout() {
    localStorage.removeItem('gc_admin_token');
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, textSize, toggleTextSize }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
